import React from 'react';

import Thumb_1 from '../../../Images/modals/films/portfolio/thumb-1.png';
import Img_1 from '../../../Images/modals/films/portfolio/img-1.png';
import Thumb_2 from '../../../Images/modals/films/portfolio/thumb-2.png';
import Img_2 from '../../../Images/modals/films/portfolio/img-2.png';
import Thumb_3 from '../../../Images/modals/films/portfolio/thumb-3.png';
import Img_3 from '../../../Images/modals/films/portfolio/img-3.png';
import Thumb_4 from '../../../Images/modals/films/portfolio/thumb-4.png';
import Img_4 from '../../../Images/modals/films/portfolio/img-4.png';
import Thumb_5 from '../../../Images/modals/films/portfolio/thumb-5.png';
import Img_5 from '../../../Images/modals/films/portfolio/img-5.png';
import Thumb_6 from '../../../Images/modals/films/portfolio/thumb-6.png';
import Img_6 from '../../../Images/modals/films/portfolio/img-6.png';
import Thumb_7 from '../../../Images/modals/films/portfolio/thumb-7.png';
import Img_7 from '../../../Images/modals/films/portfolio/img-7.png';
import Thumb_8 from '../../../Images/modals/films/portfolio/thumb-8.png';
import Img_8 from '../../../Images/modals/films/portfolio/img-8.png';
import Thumb_9 from '../../../Images/modals/films/portfolio/thumb-9.png';
import Img_9 from '../../../Images/modals/films/portfolio/img-9.png';

import MobImg_1 from '../../../Images/modals/films/portfolio/mobile/img_1-mob.png';
import MobImg_2 from '../../../Images/modals/films/portfolio/mobile/img_2-mob.png';
import MobImg_3 from '../../../Images/modals/films/portfolio/mobile/img_3-mob.png';
import MobImg_4 from '../../../Images/modals/films/portfolio/mobile/img_4-mob.png';
import MobImg_5 from '../../../Images/modals/films/portfolio/mobile/img_5-mob.png';
import MobImg_6 from '../../../Images/modals/films/portfolio/mobile/img_6-mob.png';
import MobImg_7 from '../../../Images/modals/films/portfolio/mobile/img_7-mob.png';
import MobImg_8 from '../../../Images/modals/films/portfolio/mobile/img_8-mob.png';
import MobImg_9 from '../../../Images/modals/films/portfolio/mobile/img_9-mob.png';

import NetflixLogo from '../../../Images/icons/netflix-logo.png';
import GaumontLogo from '../../../Images/icons/gaumont-logo.png';
import ParamountLogo from '../../../Images/icons/paramount-logo.png';
import AppleLogo from '../../../Images/icons/apple-tv-logo.png';
import DisneyLogo from '../../../Images/icons/disney-logo.png';
import UnivisionLogo from '../../../Images/icons/univision-logo.png';
import VixLogo from '../../../Images/icons/vix-logo.png';
import AmazonLogo from '../../../Images/icons/amazon-logo.png';
import StudiosLogo from '../../../Images/icons/amazon-studio-logo.png';
import PrimeVideoLogo from '../../../Images/icons/prime-video-logo.png';
import KuterLogo from '../../../Images/icons/kuter-logo.png';

export const TITLE_PORT = [
  {
    textSize: '3.375rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>PORTFOLIO</span>,
  },
];

export const PORT_FILMS = [
  {
    textSize: '0.75rem',
    marginBottom: '0px',
    textMobile: '0.75rem',
    renderContent: () => (
      <span>
        *All work presented in this portfolio is part of Jonathan Bouzali’s
        professional trajectory as a Producer. Each piece corresponds to
        projects in which he has directly participated in his role as Producer.
      </span>
    ),
  },
];

export const slides = [
  {
    id: 'film-1',
    category: 'FILM',
    title: 'México 86',
    description:
      'The true story of how Mexico—almost by accident and against all odds—ended up hosting the 1986 World Cup. The film reveals the mix of boldness, improvisation, corruption, and creativity that made the tournament possible amid economic crisis, devastating earthquakes, and mounting international pressure.',
    background: Img_1,
    mobBg: MobImg_1,
    thumbnail: Thumb_1,
    bgColor: 'rgba(105, 124, 13, 1)',
    logos: [
      { src: NetflixLogo, className: 'logo-netflix' },
      { src: GaumontLogo, className: 'logo-gaumon' },
    ],
  },
  {
    id: 'film-2',
    category: 'SERIES',
    title: 'Futuro Desierto',
    description:
      'After a rigorous selection process, FUZHIPIN chooses ten families and small businesses to receive androids at no cost, observing in real life how emotional bonds with AI begin to form. Gustav, a widower and company employee, lives with María—an android built from the data of his late wife. In Mexico, adolescence and cultural clash strain the household until Gustav discovers the truth: his family is also part of the experiment.',
    background: Img_2,
    mobBg: MobImg_2,
    thumbnail: Thumb_2,
    bgColor: 'rgba(144, 182, 165, 1)',
    logos: [
      { src: NetflixLogo, className: 'logo-netflix' },
      { src: ParamountLogo, className: 'logo-paramount' },
      { src: GaumontLogo, className: 'logo-gaumon' },
    ],
  },
  {
    id: 'film-3',
    category: 'SERIES',
    title: 'FAMILIA DE  MEDIANOCHE',
    description:
      'Marigaby Tamayo is an ambitious medical student who spends her nights saving lives in an overwhelming, contrasting, and captivating Mexico City—aboard her family’s private ambulance.',
    background: Img_3,
    mobBg: MobImg_3,
    thumbnail: Thumb_3,
    bgColor: 'rgba(156, 63, 65, 1)',
    logos: [{ src: AppleLogo, className: 'logo-apple' }],
  },
  {
    id: 'film-4',
    category: 'SERIES',
    title: 'EL REPATRIADO',
    description:
      'Leonel has doubts about his past, but he can’t imagine being deported to Mexico at the peak of his career—unable to prove he is a U.S. citizen.',
    background: Img_4,
    mobBg: MobImg_4,
    thumbnail: Thumb_4,
    bgColor: 'rgba(46, 100, 83, 1)',
    logos: [{ src: DisneyLogo, className: 'logo-disney' }],
  },
  {
    id: 'film-5',
    category: 'SERIES',
    title: 'TIJUANA',
    description:
      'Local journalists uncover a conspiracy behind the street assassination of a Mexican presidential candidate.',
    background: Img_5,
    mobBg: MobImg_5,
    thumbnail: Thumb_5,
    bgColor: 'rgba(164, 152, 138, 1)',
    logos: [
      { src: NetflixLogo, className: 'logo-netflix' },
      { src: UnivisionLogo, className: 'logo-univision' },
    ],
  },
  {
    id: 'film-6',
    category: 'FILM',
    title: '37KM',
    description:
      'The story of Alonso, a university professor and writer living behind appearances. His 10-year-old daughter is on the autism spectrum, and his wife, Ximena, discovers their health insurance has been canceled due to missed payments. In order to raise the money, Alonso decides to run the Mexico City Marathon and train with the legendary tarahumara tribe.',
    background: Img_6,
    mobBg: MobImg_6,
    thumbnail: Thumb_6,
    bgColor: 'rgba(182, 156, 87, 1)',
    logos: [{ src: VixLogo, className: 'logo-vix' }],
  },
  {
    id: 'film-7',
    category: 'FILM',
    title: 'souvenir',
    description:
      'To get her son back, who is being held in the United States, Isabel becomes a surrogate for a couple who can’t conceive. But an unexpected incident forces her to make extreme choices in order to hold up her end of the deal.',
    background: Img_7,
    mobBg: MobImg_7,
    thumbnail: Thumb_7,
    bgColor: 'rgba(39, 49, 18, 1)',
    logos: [{ src: AmazonLogo, className: 'logo-amzon' }],
  },
  {
    id: 'film-8',
    category: 'REALITY',
    title: 'the Bachelor Japan',
    description:
      'This romantic reality series takes the bachelor—and the audience—on a journey full of drama and passion, as multiple women compete to win his heart through group dates and intimate one-on-one encounters.',
    background: Img_8,
    mobBg: MobImg_8,
    thumbnail: Thumb_8,
    bgColor: 'rgba(187, 166, 101, 1)',
    logos: [
      { src: StudiosLogo, className: 'logo-studios' },
      { src: PrimeVideoLogo, className: 'logo-prime' },
    ],
  },
  {
    id: 'film-9',
    category: 'SHORT FILM',
    title: 'MICTLÁN',
    description:
      'Mictlán follows a group of teens who try an immersive reality game inspired by Aztec mythology. What begins as fun turns into a deadly experience when they discover that the challenges of the Mexica underworld come with real-world consequences.',
    background: Img_9,
    mobBg: MobImg_9,
    thumbnail: Thumb_9,
    bgColor: 'rgba(112, 52, 42, 1)',
    logos: [{ src: KuterLogo, className: 'logo-kuter' }],
  },
];
